import { render, staticRenderFns } from "./PicChoiceWidget.vue?vue&type=template&id=4c151b58&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PicChoiceWidget.vue?vue&type=script&lang=js&"
export * from "./PicChoiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./PicChoiceWidget.vue?vue&type=style&index=0&id=4c151b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c151b58",
  null
  
)

export default component.exports